// ============================================================
// API HEADERS — pluggable auth header provider
// ============================================================
// Web: configured at startup with localStorage + Supabase session.
// Mobile: swap the provider for AsyncStorage + Supabase RN session.
//
// Usage (web — called once in App.tsx):
//   configureApiHeaders(webApiHeadersProvider);
//
// Usage in services:
//   const headers = await getApiHeaders({ businessId });
// ============================================================

export interface ApiHeadersOptions {
  businessId?: string;
  authOnly?: boolean; // omit X-Business-Id even if businessId is known
}

export type ApiHeadersProvider = (opts: ApiHeadersOptions) => Promise<Record<string, string>>;

let _provider: ApiHeadersProvider | null = null;

export function configureApiHeaders(provider: ApiHeadersProvider) {
  _provider = provider;
}

export async function getApiHeaders(opts: ApiHeadersOptions = {}): Promise<Record<string, string>> {
  if (!_provider) throw new Error("API headers provider not configured. Call configureApiHeaders() at app startup.");
  return _provider(opts);
}
